import React from 'react';
import { updateInvestorSuitabilityMutation } from '../../../apollo';
import InvestorSuitabilityForm from './InvestorSuitabilityForm';
import AccountForm from '../AccountForm';

const InvestorSuitability = (props) => (
  <AccountForm
    title='Investor Suitability'
    Form={InvestorSuitabilityForm}
    mutation={updateInvestorSuitabilityMutation}
    {...props}
  />
);

export default InvestorSuitability;



// WEBPACK FOOTER //
// ./src/components/Account/InvestorSuitability/index.js